import { Injectable } from '@angular/core';
import { WizardModel, WizardStatus } from './WizardModel';
import { SERVICES } from '../constants/services';
import { ArticleModel, CatalogueFilters } from './ModelsModel';
import { env } from '../environments/environment';
import { ClientType } from './ClientModel';
import { AppConst } from '../services/CombeniaService/consts/AppConsts';

export class ProposalFilters {
  filter: {
    brands: Array<string>,
    materialGroupCode: Array<string>,
    proposalCode: string,
    id: string,
    distrCh: string,
    salesOrg: string
  }
  search: string;
  offset: number;
  limit: number;
  sortBy: string;
  sortOrder: string;
}

export class Cluster {
  id: string;
  name: string;
  selected: boolean = false;
  deleted: boolean = false;
  defaultQuantity: number;
  constructor() {
    //random UUID 
    this.id = (this.s4() + this.s4() + this.s4() + this.s4() + '-' + new Date().getTime().toString(36));
  }
  private s4(): string {
    var str = Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    return str;
  };
}
@Injectable()
export class ProposalModel extends WizardModel {
  id: string;

  details = [];
  clusters: Array<Cluster> = [];
  name: string;
  code: string;
  customerName: string;
  articleCount: number = 0;
  images: Array<string>;
  modelCount: number = 0;
  opticalFramesCount: number = 0;
  idClient: string;
  country: string;
  creationDate: string;
  distrCh: string;
  status: string;
  sunglassesCount: number = 0;
  totalWHS: string = '0';
  salesOrg: string;
  totalQuantity = 0;
  modificataInPopUp = false;
  removedModels: any;
  clusterTotals: Array<any> = [];


  init(obj: any = {}) {
    Object.assign(this, obj);

  }
  async load() {
    var data = await this.backend.request(SERVICES["PROPOSALS"].get, { id: this.id, offset: 0, limit: 1 });
    data = Object.assign(data, data.proposal);
    //workaround x servizio mancante
    if (!data.clusterTotals) {
      data.clusterTotals = [];
      data.clusters.forEach(element => {
        data.clusterTotals.push({
          id: element.id,
          clusterQty: 0,
          clusterWhs: 0,
        })
      });
    }
    this.init(data);
  }
  getTotalClusterQty(cluster: Cluster) {
    var finded = this.clusterTotals.find((el) => {
      return el.id == cluster.id;
    })

    return finded ? finded.clusterQty : 0;

  }
  getTotalClusterWhs(cluster: Cluster) {
    var finded = this.clusterTotals.find((el) => {
      return el.id == cluster.id;
    })

    return finded ? finded.clusterWhs : 0;

  }

  async count(filter) {
    let myFilter = Object.assign({}, filter);
    myFilter.offset = 0;
    myFilter.limit = 1;
    var data = await this.backend.request(SERVICES["PROPOSALS"].count, myFilter);
    return data["count"]
  }

  async getWizardClient() {

    var data = await this.backend.get(SERVICES["CLIENTS"].get + "/" + this.idClient);
    if (data) {
      data.idClient = this.idClient;
      data.type = this.idClient.length > 15 ? ClientType.PROSPECT : ClientType.SAP;
    }


    return data;

  }


  async getArticlesFromStyleName(styleName) {

    let filter = {
      id: this.id,
      limit: 100000,
      offset: 0,
      search: styleName,
      filter: {
        id: this.id,
        brands: [],
        category: ""
      }
    }

    return await this.getArticles(filter);

  }

  getClusterName(clusterObj) {
    var cluster = this.clusters.find((c) => { return c.id == clusterObj.id })
    return cluster.name;
  }



  getArticles(filter: any) {
    let filters = {
      id: filter.filter.id,
      limit: filter.limit,
      offset: filter.offset,
      filter: {
        brands: filter.filter.brands,
        category: (filter.filter.materialGroupCode && filter.filter.materialGroupCode.length == 1) ? filter.filter.materialGroupCode[0] : ""
      },
      search: filter.search ? filter.search : "",
      sortBy: filter.sortBy,
      sortOrder: filter.sortOrder
    }
    let listOfModels: Array<any> = [];
    let listArticles: Array<ArticleModel> = [];
    return this.backend.request(SERVICES["PROPOSALS"].getArticles, filters).then((el) => {
      console.log("getArticles")
      listOfModels = el.proposal.models;
      if (listOfModels) {
        listOfModels.forEach((model) => {
          let collectionDescr = model.details.collectionDescr;
          model.articles.forEach((article) => {
            article.details.collectionDescr = collectionDescr;
            article.details.quantity = article.quantity;
            article.details.tags = article.tags;
            article.clusters.forEach(element => {
              element.name = this.getClusterName(element);
              element.defaultQuantity = element.qty;
            });
            article.details.clusters = article.clusters;
            article.details.bestSeller = article.bestSeller;
            article.details.seasonYears = article.details.seasonCode + " " + article.details.year.substring(2, 4);
            if (article.details.images && article.details.images.cat) {
              if (article.details.images.cat.xxl && article.details.images.cat.xxl.filename)
                article.details.images.cat.xxl.filename = env.imageUrl + article.details.images.cat.xxl.filename;
              if (article.details.images.cat.s && article.details.images.cat.s.filename)
                article.details.images.cat.s.filename = env.imageUrl + article.details.images.cat.s.filename;
            }
            if (article.details.images && article.details.images.front) {
              if (article.details.images.front.xxl && article.details.images.front.xxl.filename) {
                article.details.images.front.xxl.filename = env.imageUrl + article.details.images.front.xxl.filename;
              }
              if (article.details.images.front.s && article.details.images.front.s.filename) {
                article.details.images.front.s.filename = env.imageUrl + article.details.images.front.s.filename;
              }
            }
            if (article.details.images && article.details.images.fom) {
              if (article.details.images.fom.xxl && article.details.images.fom.xxl.filename)
                article.details.images.fom.xxl.filename = env.imageUrl + article.details.images.fom.xxl.filename;
              if (article.details.images.fom.s && article.details.images.fom.s.filename)
                article.details.images.fom.s.filename = env.imageUrl + article.details.images.fom.s.filename;
            }
            article.details.isSunglass = model.isSunglass;
            article.details.isOptical = model.isOptical;
            listArticles.push(article.details);
          })
        })
      }
      return listArticles;
    }).catch((error) => {
      console.log(error);
      return listArticles;
    });
  }

  async getDetailCount(filter) {
    let filters = {
      id: filter.filter.id,
      limit: 1,
      offset: 0,
      filter: {
        brands: filter.filter.brands,
        category: (filter.filter.materialGroupCode && filter.filter.materialGroupCode.length == 1) ? filter.filter.materialGroupCode[0] : ""
      },
      search: filter.search ? filter.search : "",
      sortBy: filter.sortBy,
      sortOrder: filter.sortOrder
    }
    var tot = await this.backend.request(SERVICES["PROPOSALS"].countArticles, filters).then((el) => {
      return el.count;
    })
    return tot;
  }

  async save() {

    var data = await this.backend.request(SERVICES["PROPOSALS"].save, this.getObjToSave());
    this.id = data["id"];
    this.creationDate = data["creationDate"];
  }
  async send(params) {
    params.proposalId = this.id
    params.viewRsp = this.userModel.showPricesSRP;
    params.viewWsh = this.userModel.showPricesWHS;
    var data = await this.backend.request(SERVICES["PROPOSALS"].send, params);
    return data;
  }
  async delete() {
    var data = await this.backend.delete(SERVICES["PROPOSALS"].delete + '/' + this.id);
    return data;
  }

  //qui setta se stesso come duplicato
  async duplicate() {


    var data = await this.backend.request(SERVICES["PROPOSALS"].duplicate, {
      id: this.id,
      idClient: this.idClient
    });
    this.isDuplicated = false;
    this.init({
      id: data.id,
      status: WizardStatus.BOZZA
    });

    await this.save();
    await this.load();
  }

  async createProposal() {
    var data = await this.backend.request(SERVICES["SELECTIONS"].createProposal, {
      id: this.id,
      idClient: this.idClient,
      clusters: this.clusters,
    });
    this.isCreateProposal = false;
    this.init({
      id: data.id,
      status: WizardStatus.BOZZA,

    });

    await this.save();
    await this.load();
  }
  getCopy() {
    var copy = {};
    let key = ""
    for (key in this) {
      if (typeof this[key] === 'string' || typeof this[key] === 'number' || Array.isArray(this[key]))
        copy[key] = this[key];
    }
    return copy;
  }

  getObjToSave() {
    if (this.clusters.length > 0) {
      this.clusters.forEach((el) => {
        if (!el.defaultQuantity) {
          el.defaultQuantity = 1;
        }
      })
    }
    return {
      "idClient": this.idClient,
      "country": this.country,
      "distrCh": this.distrCh,
      "customerName": this.customerName,
      "brands": this.brands,
      "id": this.id,
      "name": this.name,
      "removedModels": null,
      "status": this.status,
      "salesOrg": this.salesOrg,
      "customerClass": this.customerClass,
      "username": this.username,
      "clusters": this.clusters
    }
  }

  isSellable(article) {

    var customerClass = this.customerClass ? this.customerClass : 'Z3';
    var fashionGrade = article.fashionGrade;

    if (fashionGrade == 'Z3' || fashionGrade == '*')
      return true;

    if (customerClass == 'Z1')
      return true;

    if (fashionGrade == customerClass)
      return true;

    return false;
    /*
    nuovo cliente --> * , Z3
    Z3 --> * , Z3
    Z2 --> * , Z3,Z2
    Z1 --> * , Z3,Z2, Z1
    */

  }



  async getList(filter: any) {

    var data = await this.backend.request(SERVICES["PROPOSALS"].list, filter);

    let list = [];

    data.forEach(lObj => {
      lObj = Object.assign(lObj, lObj.proposal);
      let item = new ProposalModel(this.backend, this.userModel);
      item.init(lObj);
      list.push(item);

    });

    return list;

  }
  async addModel(model: any) {
    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model.styleCode,
          "brandCode": model.brandCode,
          "isOptical": model.materialGroupCode == 'MG-0002',
          "isSunglass": model.materialGroupCode == 'MG-0001',
          "articles": null
        }
      ]

    }

    var data = await this.backend.request(SERVICES["PROPOSALS"].add, obj);
    await this.load();
    return data;

  }

  async removeModel(model: any) {
    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model.styleCode,
          "brandCode": model.brandCode,
          "isOptical": model.materialGroupCode == 'MG-0002',
          "isSunglass": model.materialGroupCode == 'MG-0001',
          "articles": null
        }
      ]

    }

    var data = await this.backend.request(SERVICES["PROPOSALS"].remove, obj);
    await this.load();

  }

  async addArticle(article: any, model?: any) {
    var total = 0;
    article.clusters.forEach((c) => {
      total += c.defaultQuantity;
      c.qty = c.defaultQuantity;
    });
    if (!total)
      return this.removeArticle(article, model);

    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model ? model.styleCode : article.materialCode,
          "brandCode": model ? model.brandCode : "",
          "isOptical": model ? model.materialGroupCode == 'MG-0002' : "",
          "isSunglass": model ? model.materialGroupCode == 'MG-0001' : "",
          "articles": [{
            "clusters": article.clusters,
            "skuCode": article.skuCode,

          }]
        }
      ]
    }

    var data = await this.backend.request(SERVICES["PROPOSALS"].add, obj);
    await this.load();
    return data;
  }

  async addArticleSku(upcCode: any) {
    let userCredential = localStorage.getItem(AppConst.USER_CREDENTIALS);
    let username = JSON.parse(userCredential).username

    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "upcCodes": upcCode,
      "username": username,
    }

    var data = await this.backend.request(SERVICES["PROPOSALS"].add, obj, true);
    await this.load();
    return data;
  }

  async addArticles(articles: Array<any>, model) {
    var total = 0;

    var arts = articles.map((article) => {
      return {
        "clusters": article.clusters,
        "skuCode": article.skuCode,

      }
    });

    arts.forEach((a) => {
      a.clusters.forEach((c) => {
        c.qty = c.defaultQuantity;
      });
    })


    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model.styleCode,
          "brandCode": model.brandCode,
          "isOptical": model.materialGroupCode == 'MG-0002',
          "isSunglass": model.materialGroupCode == 'MG-0001',
          "articles": arts
        }
      ]
    }

    var data = await this.backend.request(SERVICES["PROPOSALS"].add, obj);
    await this.load();
    return data;
  }

  async removeArticle(article: any, model?: any) {
    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model ? model.styleCode : article.materialCode,
          // "brandCode": model.brandCode,
          //"isOptical": model.materialGroupCode == 'MG-0002',
          //"isSunglass": model.materialGroupCode == 'MG-0001',
          "articles": [{
            "skuCode": article.skuCode,
            // "tags": article.tags
          }]
        }
      ]
    }

    var data = await this.backend.request(SERVICES["PROPOSALS"].remove, obj);
    await this.load();

  }

  async addSearch(filter: any) {
    var search = Object.assign({}, filter);
    search.limit = 300000;
    var obj = {
      "id": this.id,
      "search": search

    }

    var data = await this.backend.request(SERVICES["PROPOSALS"].add, obj);
    await this.load();

  }

  async removeBrands(brandList) {
    var filter = {
      filter: {
        brands: brandList,
        distrCh: this.distrCh,
        salesOrg: this.salesOrg,
        countryCode: this.country

      },
      offset: 0,
    }
    await this.removeSearch(filter);
  }
  async removeClusters(missingClusters: Array<Cluster>) {
    return true;
  }

  async getLastClusters() {

    var obj = {
      "idClient": this.idClient,
      "username": this.username
    }
    //elimino i fake cluster
    return await this.backend.request(SERVICES["PROPOSALS"].lastClusters, obj).then((clusters) => {
      if (clusters && clusters.length == 1 && clusters[0].id == '0000') {
        return [];
      }
      else {
        return clusters;
      }
    });

  }

  async removeSearch(filter: any) {
    var search = Object.assign({}, filter);
    search.limit = 300000;
    search.username = this.userModel.username;
    var obj = {
      "id": this.id,
      "search": search

    }

    var data = await this.backend.request(SERVICES["PROPOSALS"].remove, obj);
    await this.load();

  }

  async exportProp() {
    var name = this.name.replace(" ", "_")
    var filename = `KE_Sales_Campaign_-_${this.name}_${new Date().getTime()}.xlsx`;
    var data = await this.backend.getExcel(SERVICES["PROPOSALS"].export + "/" + this.id + "/" + `viewRsp/${this.userModel.showPricesSRP}/viewWsh/${this.userModel.showPricesWHS}`, filename);
    return data;
  }

  async getArticlesForRealTimeSummary(filter: any) {
    let articles = [];
    let details = [];
    articles = await this.getArticles(filter);
    for (var i = 0; i < articles.length; i++) {
      let dett = { qty: 0, wsh: 0, sun: 0, opt: 0, sku: 0 };
      dett['brandName'] = this.userModel.getBrandNameFromCode(articles[i].brandCode);
      if (details.find((a) => { return a.brandName == dett['brandName'] })) {
        details.forEach((el) => {
          if (el.brandName == dett['brandName']) {
            let qtyAtt = 0;
            articles[i].clusters.forEach((cl) => {
              el.qty += cl.defaultQuantity;
              qtyAtt += cl.defaultQuantity;
            })
            el.sku += 1;
            if (articles[i].isSunglass)
              el.sun += 1;
            if (articles[i].isOptical)
              el.opt += 1;
            el.wsh += (qtyAtt * articles[i].price.wshGross);
          }
        });
      } else {
        articles[i].clusters.forEach((cl) => {
          dett.qty += cl.defaultQuantity;
        })
        dett.sku = 1;
        dett.sun = articles[i].isSunglass ? 1 : 0;
        dett.opt = articles[i].isOptical ? 1 : 0;
        dett.wsh = dett.qty * articles[i].price.wshGross;
        details.push(dett);
      }
    }
    // Aggiungo il total
    details.push({
      brandName: 'TOTAL',
      qty: this.totalQuantity,
      sku: this.articleCount,
      wsh: this.totalWHS,
      opt: this.opticalFramesCount,
      sun: this.sunglassesCount
    })
    console.log(details);
    return details;
  }
}